<template>
    <div>
       <br />
        <h2 class="ViewHeading">Savings Calculator</h2>
        <br/>
        <b-card v-if="!this.UserAccess.includes('SAV') || this.UserProfile != 'SUP'">
          You do not have permission to view this content
        </b-card>
        <b-card v-if="this.UserAccess.includes('SAV') || this.UserProfile == 'SUP'">
          <b-tabs>
            <b-tab title="Calculation">
              <b-card>
               <b-row><b-col><b>Please insert values based on one week</b></b-col></b-row>
                <br/>
               <b-row>
            <b-col><b-card>
          <b-row><b-col>Total No of Outlets</b-col></b-row>
          <b-row><b-col>
             <b-form-input id="inputone" v-model="TotalOutlets" type="number"></b-form-input>
          </b-col></b-row>
          <br/>
          <b-row><b-col>How many of these Manually Flushed</b-col></b-row>
            <b-row><b-col>
             <b-form-input id="inputtwo" v-model="OutletsManFlushed" type="number"></b-form-input>
          </b-col></b-row>
           <br/>
          <b-row><b-col>How many of these Manually Temperature Tested</b-col></b-row>
            <b-row><b-col>
             <b-form-input id="inputtwo" v-model="OutletsManTemp" type="number"></b-form-input>
          </b-col></b-row>
          <br/>
          <b-row><b-col>Outlets to be monitored remotely</b-col></b-row>
            <b-row><b-col>
              <b-form-input id="inputthree" v-model="RemoteOutlets" type="range" min="1" :max=this.TotalOutlets step="1"></b-form-input>
          </b-col></b-row>
          <b-row><b-col><h4>{{ this.RemoteOutlets }}</h4></b-col></b-row>
          <hr/>
          <b-row><b-col>Flush Duration (mins)</b-col><b-col>Water Flow Rate(L/min)</b-col></b-row>
          <b-row><b-col><b-form-spinbutton id="inputfive" v-model="FlushDuration" min="1" max="15" inline></b-form-spinbutton></b-col>
          <b-col><b-form-spinbutton id="inputsix" v-model="WaterFlowRate" min="1" max="15" inline></b-form-spinbutton></b-col></b-row>
          <br/>
          <b-row><b-col>Water Cost (£/L)</b-col><b-col>Electric Cost (£/kWh)</b-col></b-row>
          <b-row><b-col><b-form-input id="inputseven" type="number" v-model="WaterCost" min="0.001" max="3.000" step="0.001" inline></b-form-input></b-col>
          <b-col><b-form-input id="inputeight" type="number" v-model="ElectricCost" min="0.01" max="3.000" step="0.01" inline></b-form-input></b-col></b-row>
          <br/>
          <b-row><b-col>Visits to Site per week</b-col></b-row>
            <b-row><b-col>
            <b-form-spinbutton id="inputnine" v-model="SiteVisits" type="number" min="1" max="100"></b-form-spinbutton>
          </b-col></b-row>
          <br/>
          <b-row><b-col>Percentage of Fleet that is Electric</b-col></b-row>
            <b-row><b-col>
              <b-form-input id="inputten" v-model="ElectricFleet" type="range" min="0" max="100" step="1"></b-form-input>
          </b-col></b-row>
          <b-row><b-col><h4>{{ this.ElectricFleet }}%</h4></b-col></b-row>
          <hr/>
          <b-row><b-col>How many Outlets have PoU Filters Fitted </b-col></b-row>
            <b-row><b-col>
             <b-form-input id="inputfour" v-model="OutletsFiltered" type="number" min="1" :max=this.TotalOutlets></b-form-input>
          </b-col></b-row>
          <br/>
          <b-row><b-col>PoU Filter Cost (£) </b-col></b-row>
          <b-row><b-col><b-form-input id="inputeleven" type="number" v-model="FilterCost" min="1.00" max="200.00" step="0.50" inline></b-form-input></b-col></b-row>
          <hr/>
          <b-row><b-col>No Of Outlets tested for pathogens</b-col></b-row>
          <b-row><b-col><b-form-input id="inputtwelve" v-model="OutletsPathoTested" type="range" min="0" :max=this.TotalOutlets step="1"></b-form-input></b-col></b-row>
          <b-row><b-col><h4>{{ this.OutletsPathoTested }}</h4></b-col></b-row>
          <br/>
          <b-row><b-col>Tests per year per outlet</b-col><b-col>Cost per test(£)</b-col></b-row>
          <b-row><b-col><b-form-input id="inputthirteen" type="number" v-model="NoOfPathoTestsPerYear" min="0" max="100" step="1" inline></b-form-input></b-col>
          <b-col><b-form-input id="inputeleven" type="number" v-model="PathoTestCost" min="1.00" max="200.00" step="0.50" inline></b-form-input></b-col></b-row>
          <hr/>
          <b-row><b-col><b-button v-on:click="ResetValues()" variant="outline-info">Reset</b-button></b-col><b-col><b-button  v-on:click="GenerateStart()" variant="outline-info">Calculate</b-button></b-col></b-row>
          

        </b-card></b-col>
                <b-col>
                    <b-card>
                      <b-row><b-col align="center"><H3>Projected Annual Savings</H3></b-col></b-row>
                       <b-row>
              <b-col>
            <b-card align="center" :img-src="require('../assets/Piggy.png')" img-height="128" img-width="128" img-left border-variant="info">
              <b-card-text>
              <b-row><b-col><p class="cardtext">Money Saved</p></b-col></b-row>
              <!-- <b-row><b-col><p class="savingtext">£{{ this.MoneySaved}}</p></b-col></b-row> -->
              <b-row><b-col><p class="savingtext">£{{ this.AnnualMoney}}</p></b-col></b-row>
             
            </b-card-text>
            </b-card>
            </b-col>
          </b-row>
          <br/>
          <b-row>
            <b-col>
             <b-card align="center" header-bg-variant="secondary" :img-src="require('../assets/clock.png')" img-height="128" img-width="128" img-left border-variant="info">
              <b-card-text>
              <b-row><b-col><p class="cardtext">Time Saved</p></b-col></b-row>
              <!-- <b-row><b-col><p class="savingtext">{{ this.TimeSaved }} hrs</p></b-col></b-row> -->
              <b-row><b-col><p class="savingtext">{{ this.AnnualTime }} days</p></b-col></b-row>
            </b-card-text>
          </b-card>
          </b-col>
          </b-row>
          <br/>
            <b-row>
              <b-col>
                <b-card  align="center" header-bg-variant="info" :img-src="require('../assets/WaterSplash.png')" img-height="128" img-width="128" img-left border-variant="info">
      <b-card-text>
              <b-row><b-col><p class="cardtext">Water Saved</p></b-col></b-row>
              <!-- <b-row><b-col><p class="savingtext">{{ this.WaterSaved }} Litres</p></b-col></b-row> -->
              <b-row><b-col><p class="savingtext">{{ this.AnnualWater }} Litres</p></b-col></b-row>
            </b-card-text>
      </b-card>
          </b-col>
          </b-row>
          <br/>
            <b-row>
              <b-col>
                <b-card align="center" header-bg-variant="info"  :img-src="require('../assets/Energy.png')" img-height="128" img-width="128" img-left border-variant="info">
      <b-card-text>
              <b-row><b-col><p class="cardtext">Energy Saved</p></b-col></b-row>
              <!-- <b-row><b-col><p class="savingtext">{{ this.EnergySaved }} kWh</p></b-col></b-row> -->
              <b-row><b-col><p class="savingtext">{{ this.AnnualEnergy }} kWh</p></b-col></b-row>
      </b-card-text>
            </b-card>
            </b-col>
          </b-row>
          <br/>
            <b-row>
              <b-col>
                <b-card align="center" header-bg-variant="info" :img-src="require('../assets/Co2red.png')" img-height="128" img-width="128" img-left border-variant="info">
      <b-card-text>
              <b-row><b-col><p class="cardtext">CO2e Reduction</p></b-col></b-row>
              <!-- <b-row><b-col><p class="savingtext">{{ this.CO2eSaved}} kg</p></b-col></b-row> -->
              <b-row><b-col><p class="savingtext">{{ this.AnnualCO2}} kg</p></b-col></b-row>
      </b-card-text>
            </b-card>
            </b-col>
            </b-row>
  </b-card>
</b-col>
</b-row>
                <hr/>
      <b-row><b-col>
        <b-card align="center">
          <VueApexCharts type="line" height="350" :options="this.chartOptions" :series="this.series"></VueApexCharts>
            <H4>Full Return on Investment expected after {{ this.ROI }} Months</H4>
        </b-card>
        </b-col></b-row>
              </b-card>
            </b-tab>
            <b-tab title="Update Prices">
              <b-card>
                <b-row><b-col>O1 Cost</b-col>
                <b-col><b-form-input v-model="NewPrice['O1']" type="number"></b-form-input></b-col></b-row>
                <b-row><b-col>Gateway Cost</b-col>
                <b-col><b-form-input v-model="NewPrice['Gateway']" type="number"></b-form-input></b-col></b-row>
                <b-row><b-col>Temp Sensors</b-col>
                <b-col><b-form-input v-model="NewPrice['TProbes']" type="number"></b-form-input></b-col></b-row>
                <b-row><b-col>C1 Device</b-col>
                <b-col><b-form-input v-model="NewPrice['C1Device']" type="number"></b-form-input></b-col></b-row>
                <b-row><b-col>C1 Biofilm Box</b-col>
                <b-col><b-form-input v-model="NewPrice['C1BioBox']" type="number"></b-form-input></b-col></b-row>
                <b-row><b-col>Data Cost</b-col>
                <b-col><b-form-input v-model="NewPrice['Data']" type="number"></b-form-input></b-col></b-row>
                <hr/>
                <b-row><b-col></b-col><b-col><b-button variant="outline-info" v-on:click="UpdatePrices('Reset')">Reset</b-button></b-col><b-col><b-button v-on:click="UpdatePrices('Update')" variant="outline-success">Save</b-button></b-col></b-row>
              </b-card>
            </b-tab>
          </b-tabs>
    </b-card>
    </div>
    </template>
     <script>

     import VueApexCharts from "vue-apexcharts";


  export default {
  
    data() {
      return {
        selectedlocation: localStorage.getItem("location"),
        UserAccess: localStorage.getItem("accessGroup"),
        UserProfile: localStorage.getItem("profileportal"),

        //AG Inputs
        Pricing: {
          C1Device: 350.00,
          C1BioBox: 160.00,
          O1: 330.00,
          Gateway: 210.00,
          Data: 5.00,
          TProbes: 10.00
        },
        NewPrice:{
          C1Device: 350.00,
          C1BioBox: 160.00,
          O1: 330.00,
          Gateway: 210.00,
          Data: 5.00,
          TProbes: 10.00
        },
        //User Inputs
        TotalOutlets: 200,
        RemoteOutlets: 35,
        OutletsManFlushed: 35,
        OutletsManTemp: 35,
        FlushDuration: 2,
        WaterFlowRate: 6,
        WaterCost: 0.004,
        ElectricCost: 0.25,
        SiteVisits: 1,
        ElectricFleet: 40,
        OutletsFiltered: 0,
        FilterCost: 60,
        OutletsPathoTested: 35,
        NoOfPathoTestsPerYear: 12,
        PathoTestCost: 35,


        //Returns
        TimeSaved: 0,
        WaterSaved: 0,
        EnergySaved: 0,
        MoneySaved: 0,
        CO2eSaved: 0,
        ROI: 0,


        //Static Values
        avgMilesPerTrip: 40,
        avgHrsTravelTime: 0.75,
        avgFlushTime: 0.1,
        avgFilterTime: 0.25,
        avgPathoTime: 0.25,
        avgManTempTime: 0.1,
        avgStaffCost: 23.30,
        avgMPG: 30,
        avgFuelCost: 5.70,
        WaterToKWh: 0.05,
        CO2ePerKWh: 0.15,
        CO2ePerMile: 0.38,
        WaterPerPatho: 1.5,
        WaterPerManTemp: 9,
        KWhPerMile: 3.2,
        ManFlushAssRed: 0.5,
        FilterAssRed: 0.33,
        PathoAssRed: 0.7,

        //calculated values
        ManTempAssRed: 0,
        VanTravelAssRed: 0,
        ClarenceCost: 0,
        ClarenceData: 0,
        GatewayCost: 0,
        NoOfGateways: 0,
        TotalHardwareCost: 0,
        CurrentSpend: 0,
        MonthlyCurrent: 0,
        ClarenceArray: [],
        CurrentArray: [],
        CategoryArray:[],
        AnnualTime: 0,
        AnnualMoney: 0,
        AnnualEnergy: 0,
        AnnualWater: 0,
        AnnualCO2: 0,
        GaryTemp: 0,

        //Graph Values
        series: [
            {
              name: "Current Spending - Projection",
              data: []
            },
            {
              name: "Total Spend with Clarence - Projection",
              data: []
            }
          ],
          chartOptions: {
            chart: {
              height: 350,
              type: 'line',
              zoom: {
                enabled: false
              },
              toolbar: {
                show: true,
                offsetX: 0,
                offsetY: 0,
                tools:{
                  download: true,
                  selection: false,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true | '<img src="/static/icons/reset.png" width="20">',
                  customIcons: []
                },
                export:{
                  scale: undefined,
                  width: undefined,
                  csv: {
                    filename: "AngelGuardCostSavings",
                    columnDelimiter: ',',
                    headerCategory: 'category',
                    headerValue: 'value',
                    categoryFormatter(x) {
                      return x
                      },
                    valueFormatter(y) {
                      return y
                      }
                    },
                  svg: {
                    filename: "AngelGuardCostSavings",
                      },
                  png: {
                    filename: "AngelGuardCostSavings",
                      }
                }
              }
            },
            colors: ['#b4b8b7','#03d3fc'],
            dataLabels: {
              enabled: true,
            },
            stroke: {
              curve: 'smooth'
            },
            title: {
              text: 'Return on Investment',
              align: 'left'
            },
            grid: {
              borderColor: '#e7e7e7',
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              },
            },
            markers: {
              size: 1
            },
            xaxis: {
              categories: [],
              title: {
                text: 'Time'
              }
            },
            yaxis: {
              title: {
                text: 'Total Spend'
              },
              min: 500,
              max: 30000
            },
            legend: {
              position: 'top',
              horizontalAlign: 'right',
              floating: true,
              offsetY: 0,
              offsetX: 0
            }
          },
      };
    },
    computed:{},
    beforeMount(){},
    mounted() {
      this.BaseValueCalculations()
      this.CalculateValues()
    },
    components: {
      VueApexCharts,
    },
    methods: {

      BaseValueCalculations(){
        //Calc Man temp Testing Percentage
      let var1 = ((this.RemoteOutlets/12)+(this.OutletsManTemp - this.RemoteOutlets))/this.OutletsManTemp
      let var2 = (1-var1)*100
      this.ManTempAssRed = Math.round(var2)/100
      // calc van travel to site
      let var3 = (this.ManTempAssRed+this.ManFlushAssRed+this.FilterAssRed+this.PathoAssRed)/4
      var3 = var3*100
      this.VanTravelAssRed = Math.round(var3)/100
      // Calc Clarence Cost
      this.ClarenceCost = this.RemoteOutlets*this.Pricing['O1']
      // calc data cost
      this.ClarenceData = this.RemoteOutlets*this.Pricing['Data']
      // Calc no and cost of Gateways
      if(this.RemoteOutlets <= 15){
        this.NoOfGateways = 1
      } else{
        this.NoOfGateways = Math.ceil(this.RemoteOutlets/15)
      }
      this.GatewayCost = this.NoOfGateways*this.Pricing['Gateway']
      //Total Hardware Costs
      this.TotalHardwareCost = this.ClarenceCost+this.GatewayCost
      },

      CalculateValues(){
        //recalculate base calculations after value change
        this.BaseValueCalculations()
        //Manual Temp Saving Calcs
         let manTempTimeUsed = (12/52)*((Number(this.OutletsManTemp)+((Number(this.TotalOutlets)-Number(this.OutletsManTemp))/12))*Number(this.avgManTempTime));
         let manTempTimeSaved = this.ManTempAssRed*manTempTimeUsed;
         let manTempWaterUsed = (12/52)*((Number(this.OutletsManTemp)+(Number(this.TotalOutlets)-Number(this.OutletsManTemp))/12)*Number(this.WaterPerManTemp));
         let manTempWaterSaved = this.ManTempAssRed*manTempWaterUsed;
         let manTempEnergyUsed = (12/52)*(Number(this.OutletsManTemp)+((Number(this.TotalOutlets)-Number(this.OutletsManTemp))/12))*Number(this.WaterPerManTemp)*Number(this.WaterToKWh);
         let manTempEnergySaved = this.ManTempAssRed*manTempEnergyUsed;
         let manTempMoneyUsed = (12/52)*((Number(this.OutletsManTemp)+((Number(this.TotalOutlets)-Number(this.OutletsManTemp))/12))*Number(this.avgManTempTime)*Number(this.avgStaffCost)+(Number(this.OutletsManTemp)+((Number(this.TotalOutlets)-Number(this.OutletsManTemp))/12))*Number(this.WaterPerManTemp)*Number(this.WaterCost)+(Number(this.OutletsManTemp)+((Number(this.TotalOutlets)-Number(this.OutletsManTemp))/12))*Number(this.WaterPerManTemp)*Number(this.WaterToKWh)*Number(this.ElectricCost));
         let manTempMoneySaved = this.ManTempAssRed*manTempMoneyUsed;
         let manTempCO2eUsed = (12/52)*manTempEnergyUsed*Number(this.CO2ePerKWh);
         let manTempCO2eSaved = this.ManTempAssRed*manTempCO2eUsed;

        //Filter Saving Calcs
         let FilterTimeUsed = (12/52)*Number(this.OutletsFiltered)*Number(this.avgFilterTime);
         let FilterTimeSaved = this.FilterAssRed * FilterTimeUsed;
         let FilterWaterUsed = 0;
         let FilterWaterSaved = this.FilterAssRed * FilterWaterUsed;
         let FilterEnergyUsed = 0;
         let FilterEnergySaved = this.FilterAssRed * FilterEnergyUsed;
         let FilterMoneyUsed = (12/52)*(Number(this.OutletsFiltered)*Number(this.FilterCost)+Number(this.OutletsFiltered)*Number(this.avgFilterTime)*Number(this.avgStaffCost));
         let FilterMoneySaved = this.FilterAssRed * FilterMoneyUsed;
         let FilterCO2eUsed = 0;
         let FilterCO2eSaved = this.FilterAssRed * FilterCO2eUsed;

        //Pathogen Testing Saving Calcs
         let PathoTimeUsed = (Number(this.NoOfPathoTestsPerYear)/52)*Number(this.OutletsPathoTested)*Number(this.avgPathoTime);
         let PathoTimeSaved = this.PathoAssRed * PathoTimeUsed;
         let PathoWaterUsed = (Number(this.NoOfPathoTestsPerYear)/52)*Number(this.OutletsPathoTested)*Number(this.WaterPerPatho);
         let PathoWaterSaved = this.PathoAssRed * PathoWaterUsed;
         let PathoEnergyUsed = (Number(this.NoOfPathoTestsPerYear)/52)*Number(this.OutletsPathoTested)*Number(this.WaterPerPatho)*Number(this.WaterToKWh);
         let PathoEnergySaved = this.PathoAssRed * PathoEnergyUsed;
         let PathoMoneyUsed = (Number(this.NoOfPathoTestsPerYear)/52)*(Number(this.OutletsPathoTested)*Number(this.PathoTestCost)+Number(this.OutletsPathoTested)*Number(this.WaterPerPatho)*Number(this.WaterCost)+Number(this.OutletsPathoTested)*Number(this.WaterPerPatho)*Number(this.WaterToKWh)*Number(this.ElectricCost)+Number(this.OutletsPathoTested)*Number(this.avgPathoTime)*Number(this.avgStaffCost));
         let PathoMoneySaved = this.PathoAssRed * PathoMoneyUsed;
         let PathoCO2eUsed = (Number(this.NoOfPathoTestsPerYear)/52)*PathoEnergyUsed*Number(this.CO2ePerKWh);
         let PathoCO2eSaved = this.PathoAssRed * PathoCO2eUsed;
  
         //Manual Flush Saving Calcs
         let manFlushTimeUsed = Number(this.OutletsManFlushed) * Number(this.avgFlushTime);
         let manFlushTimeSaved = this.ManFlushAssRed * manFlushTimeUsed;
         let manFlushWaterUsed = Number(this.OutletsManFlushed) * Number(this.FlushDuration) * Number(this.WaterFlowRate);
         let manFlushWaterSaved = this.ManFlushAssRed * manFlushWaterUsed;
         let manFlushEnergyUsed = Number(this.OutletsManFlushed) * Number(this.FlushDuration) * Number(this.WaterFlowRate) * Number(this.WaterToKWh);
         let manFlushEnergySaved = this.ManFlushAssRed * manFlushEnergyUsed;
         let manFlushMoneyUsed = Number(this.OutletsManFlushed) * Number(this.avgFlushTime)*Number(this.avgStaffCost)+Number(this.OutletsManFlushed)*Number(this.FlushDuration)*Number(this.WaterFlowRate)*Number(this.WaterCost)+Number(this.OutletsManFlushed)*Number(this.FlushDuration)*Number(this.WaterFlowRate)*Number(this.WaterToKWh)*Number(this.ElectricCost);
         let manFlushMoneySaved = this.ManFlushAssRed * manFlushMoneyUsed;
         let manFlushCO2eUsed = Number(this.OutletsManFlushed) * Number(this.FlushDuration) * Number(this.WaterFlowRate) * Number(this.WaterToKWh) * Number(this.CO2ePerKWh);
         let manFlushCO2eSaved = this.ManFlushAssRed * manFlushCO2eUsed;
       
        //Travel Saving Calcs
        let TravelTimeUsed = Number(this.SiteVisits) * Number(this.avgHrsTravelTime) * 2;
        let TravelTimeSaved = this.VanTravelAssRed * TravelTimeUsed;
        let TravelWaterUsed = 0;
        let TravelWaterSaved = this.VanTravelAssRed * TravelWaterUsed;
        let TravelEnergyUsed = (Number(this.ElectricFleet)/100)*Number(this.SiteVisits)*2*Number(this.avgMilesPerTrip)*Number(this.KWhPerMile);
        let TravelEnergySaved = this.VanTravelAssRed * TravelEnergyUsed;
        let TravelMoneyUsed = Number(this.SiteVisits)*Number(this.avgHrsTravelTime)*2*Number(this.avgStaffCost)+(1-(Number(this.ElectricFleet)/100))*Number(this.SiteVisits)*2*Number(this.avgMilesPerTrip)*(Number(this.avgFuelCost)/Number(this.avgMPG))+(Number(this.ElectricFleet)/100)*Number(this.SiteVisits)*2*Number(this.avgMilesPerTrip)*Number(this.ElectricCost)*Number(this.KWhPerMile);
        let TravelMoneySaved = this.VanTravelAssRed * TravelMoneyUsed;
        let TravelCO2eUsed = (Number(this.ElectricFleet)/100)*Number(this.SiteVisits)*2*Number(this.avgMilesPerTrip)*Number(this.KWhPerMile)*Number(this.CO2ePerKWh)+(1-(Number(this.ElectricFleet)/100))*Number(this.SiteVisits)*2*Number(this.avgMilesPerTrip)*Number(this.CO2ePerMile);
        let TravelCO2eSaved = this.VanTravelAssRed * TravelCO2eUsed;

        this.MoneySaved = manTempMoneySaved + FilterMoneySaved + PathoMoneySaved + manFlushMoneySaved + TravelMoneySaved
        this.MoneySaved = this.MoneySaved.toFixed(2);
        this.AnnualMoney = (this.MoneySaved - this.ClarenceData) *12;
        this.AnnualMoney = this.AnnualMoney.toFixed(2)

        this.TimeSaved = manTempTimeSaved + FilterTimeSaved + PathoTimeSaved + manFlushTimeSaved + TravelTimeSaved
        this.TimeSaved = this.TimeSaved.toFixed(2);
        this.AnnualTime = (this.TimeSaved * 12)/24
        this.AnnualTime = this.AnnualTime.toFixed(2)


        this.WaterSaved = manTempWaterSaved + FilterWaterSaved + PathoWaterSaved + manFlushWaterSaved + TravelWaterSaved
        this.WaterSaved = Math.round(this.WaterSaved);
        this.AnnualWater = this.WaterSaved*12
        this.AnnualWater = Math.round(this.AnnualWater)


        this.EnergySaved = manTempEnergySaved + FilterEnergySaved + PathoEnergySaved + manFlushEnergySaved + TravelEnergySaved
        this.EnergySaved = this.EnergySaved.toFixed(4);
        this.AnnualEnergy = this.EnergySaved*12
        this.AnnualEnergy = this.AnnualEnergy.toFixed(4);


        this.CO2eSaved = manTempCO2eSaved + FilterCO2eSaved + PathoCO2eSaved + manFlushCO2eSaved + TravelCO2eSaved
        this.CO2eSaved = this.CO2eSaved.toFixed(2)
        this.AnnualCO2 = this.CO2eSaved*12
        this.AnnualCO2 = this.AnnualCO2.toFixed(2)

        
        this.ROI = this.TotalHardwareCost/(((52/12)*this.MoneySaved)-this.ClarenceData)
        this.ROI = Math.ceil(this.ROI)
      
        //Monthly Saving Calculations for use in Graphing
        this.MonthlyCurrent = this.MoneySaved*(52/12)
        this.MonthlyCurrent = Math.round(this.MonthlyCurrent)

        //Monthly Spend Calc for use in
        this.CurrentSpend = manTempMoneyUsed + FilterMoneyUsed + PathoMoneyUsed + manFlushMoneyUsed + TravelMoneyUsed
        this.CurrentSpend = Math.round(this.CurrentSpend)



        this.GenerateGraph()
      },
      GenerateGraph(){
        let graphlength = this.ROI*2
        let ClarenceStart = this.TotalHardwareCost
        let CurrentStart = this.CurrentSpend
        this.ClarenceArray = []
        this.CurrentArray = []
        this.CategoryArray = []
       
        for (let i=0;i<graphlength;i++){
          this.ClarenceArray.push(ClarenceStart)
          this.CurrentArray.push(CurrentStart)
          this.CategoryArray.push("Month "+(i+1))
          ClarenceStart = ClarenceStart+this.ClarenceData
          CurrentStart = CurrentStart+this.MonthlyCurrent
        }
        let currentmax = Math.max(...this.CurrentArray)
        let clarencemax = Math.max(...this.ClarenceArray)
        let maxval = 30000
        if(currentmax < clarencemax){
          maxval = clarencemax + 5000
        } else{
          maxval = currentmax + 5000
        }

        this.chartOptions= {
            chart: {
              height: 450,
              type: 'line',
              zoom: {
                enabled: false
              },
              toolbar: {
                show: true,
                offsetX: 0,
                offsetY: 0,
                tools:{
                  download: true,
                  selection: false,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true | '<img src="/static/icons/reset.png" width="20">',
                  customIcons: []
                },
                export:{
                  scale: undefined,
                  width: undefined,
                  csv: {
                    filename: "AngelGuardCostSavings",
                    columnDelimiter: ',',
                    headerCategory: 'category',
                    headerValue: 'value',
                    categoryFormatter(x) {
                      return x
                      },
                    valueFormatter(y) {
                      return y
                      }
                    },
                  svg: {
                    filename: "AngelGuardCostSavings",
                      },
                  png: {
                    filename: "AngelGuardCostSavings",
                      }
                }
              }
            },
            colors: ['#b4b8b7','#03d3fc'],
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'smooth'
            },
            title: {
              text: 'Return on Investment',
              align: 'left'
            },
            grid: {
              borderColor: '#e7e7e7',
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              },
            },
            markers: {
              size: 1
            },
            xaxis: {
              categories: this.CategoryArray,
              title: {
                text: 'Time'
              }
            },
            yaxis: {
              title: {
                text: 'Total Spend'
              },
              min: 500,
              max: maxval
            },
            legend: {
              position: 'top',
              horizontalAlign: 'right',
              floating: true,
              offsetY: 0,
              offsetX: 0
            }
          },
          this.series= [
            {
              name: "Current Spending - Projection",
              data: this.CurrentArray
            },
            {
              name: "Total Spend with Clarence - Projection",
              data: this.ClarenceArray
            }
          ]
      },
      UpdatePrices(Action){
       if(Action == "Update"){
        this.Pricing = this.NewPrice
       } else {
          this.Pricing = {
          C1Device: 500.00,
          C1BioBox: 120.00,
          O1: 350.00,
          Gateway: 220.00,
          Data: 10.00,
          TProbes: 15.00
        }
        this.NewPrice = this.Pricing
        }
        this.BaseValueCalculations()
      },
      GenerateStart(){
        this.CalculateValues()
      },
      ResetValues(){
        //reset user inputs back to defaults
        this.TotalOutlets = 200,
        this.RemoteOutlets = 35,
        this.OutletsManFlushed = 35,
        this.OutletsManTemp = 35,
        this.FlushDuration = 2,
        this.WaterFlowRate = 6,
        this.WaterCost = 0.004,
        this. ElectricCost = 0.25,
        this.SiteVisits = 1,
        this.ElectricFleet = 40,
        this.OutletsFiltered = 0,
        this.FilterCost = 60,
        this.OutletsPathoTested = 35,
        this.NoOfPathoTestsPerYear = 12,
        this.PathoTestCost = 35,
        //redo calculate values
        this.CalculateValues()
      }
    },
    watch: {
     
    },
 
  };
  </script>
  <style scoped>
  .cardtext{
    text-decoration: underline;
    font-style: italic;
    font-size: large;
  }
  .savingtext{
    font-style: bold;
    font-size: xx-large;
  }
</style>